module.exports = __webpack_public_path__ + "img/img-meal-plan-intro.a7749f2b.svg";